import { platform } from '@/shared/lib/platform/platform'

/** Abre URL externa (Custom Tabs no nativo; nova aba na PWA). */
export const openExternal = async (url: string): Promise<void> => {
  if (platform.isNative()) {
    const { Browser } = await import('@capacitor/browser')
    await Browser.open({ url, presentationStyle: 'popover' })
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

/** Fecha Custom Tabs no nativo; no-op na web. */
export const closeBrowser = async (): Promise<void> => {
  if (platform.isNative()) {
    const { Browser } = await import('@capacitor/browser')
    await Browser.close()
  }
}
